import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsDumbbell from 'highcharts/modules/dumbbell';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsLollipop from 'highcharts/modules/lollipop';
import { LollipopService } from '../../lollipop.service';
import Stock from 'highcharts/modules/stock';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { ActivatedRoute } from '@angular/router';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { BarserviceService } from '../../../../barchart/barchart/barservice.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SignificanceService } from 'src/app/common/services/significance.service';
Stock(Highcharts);

HighchartsMore(Highcharts);
HighchartsDumbbell(Highcharts);
HighchartsAccessibility(Highcharts);
HighchartsLollipop(Highcharts);

@Component({
  selector: 'app-lollipopchart02-custom',
  template: `
    <div [id]="'chart-container'+id" [ngStyle]="{ height: popUp ? '28em' : height }"></div>
  `,
})
export class Lollipopchart02ComponentCustom implements OnDestroy {
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any=0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any="24em";
  chart: any;
  event: any;
  lollipopChartData: any;
  properties: any;
  changeValueSeries: any;
  maxBarValue = 0;
  significance: any;
  significanceValue2: any;
  sampleSize: any;
  data: any;
  max: any;
  min: any;
  public seriesData1: any[] = [];
  public seriesDataTop10 : any[] = [];
  jsonData: any;
  chartCategories: any[] = [];
  categoryImages: any;
  userselectedchartdata:any;
  datalabel: any = false;
  barChartData: any;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  defaultCategories1: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = "#ff0000";
  maxDataPoints: any = 8;
  maxSeries: any;
  @Input() isOutput: any;
  selectedMetric: any = '';
  hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;

  constructor(private http: HttpClient, private LollipopService: LollipopService,private _customSnapshotService:CustomsnapshotService, private route: ActivatedRoute, private _configService: SnapshotService, private barService: BarserviceService, private significanceService: SignificanceService) { }
  private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  configuredProperties:any;
  private resizeHandler: (() => void) | null = null;
  ngOnInit(): void {

    if (this.isOutput) {
      this.configuredProperties=JSON.parse(this.customData.customizationProperties);
      const metricFromData = this.customData?.selectedMetric || '';
      this.customData = this.customData.metric[0];
      this.applyCustomMetricExtensions();
      if(this.configuredProperties?.sort=="default")this.customData.metric_value.sort((a: any, b: any) => a.selectOrder - b.selectOrder);
      this.selectedMetric = this._customSnapshotService.getSelectedMetricSync(this.id) || metricFromData;
      if (this.selectedMetric) {
        this.LollipopService.selectedMetric = this.selectedMetric;
      }
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._customSnapshotService.getSelectedMetric(this.id).subscribe((selectedMetric) => {
          if (selectedMetric) {
            this.selectedMetric = selectedMetric;
            this.LollipopService.selectedMetric=this.selectedMetric; // Update the service with the new selection
            this.updateSig();
          }
        }));
    }
    else{
      this.http.get<any>('assets/Data/lollipopdata.json').subscribe((data: any) => {
        this.jsonData = data;
        this.data = data[0];
        this.lollipopChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.showLegend=true;
        this.properties.legendPosition="bottom";
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.getData(this.jsonData, this.properties.datalabelStyle == "lowSample");
        this.getChart('chart-container'+this.id, this.seriesData1, this.seriesDataTop10, this.properties);
      });
    }

  }
 private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
      this.ngOnInit();
    }
  }

  chartMainData: any = [];
  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        //this.data = data[0];
        this.barChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        // ;
        this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
        // this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
        // this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
        if (this.hasCustomMetricSignificance) {
          this.properties.datalabelStyle = "default";
        } else {
          this.properties.datalabelStyle =
            this.significanceValue == "None"
              ? "default"
              : "sigChange";
        }


        if (
          this._configService.isIndexSelected &&
          !this.hasCustomMetricIndex
        ) {
          this.properties.datalabelStyle = "index";
        }
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        this.preparemainChartData(this.customData, this.resolveMetricFilter(this.customData, this.selectedMetric));
        this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
        this.getChart('chart-container' + this.id, this.seriesData1, this.seriesDataTop10, this.properties);
      }));

  }
  private shouldUseMetricAsCategory(data: any, metricFilter: string): boolean {
    if (metricFilter) {
      return false;
    }
    const metricValues = data?.metric_value ?? [];
    if (metricValues.length > 1) {
      return true;
    }
    if (metricValues.length === 1) {
      const rowChildren = new Set(
        (metricValues[0].data ?? []).map((d: any) => d.rowChild).filter(Boolean)
      );
      return rowChildren.size > 1;
    }
    return false;
  }

  private shouldUseBrandAsCategory(data: any, metricFilter: string): boolean {
    if (!this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return false;
    }
    return !this.shouldUseMetricAsCategory(data, metricFilter);
  }

  private resolveMetricDisplayName(lev2: any, dataArr: any): string {
    const option = lev2?.option?.trim();
    if (option) {
      return option;
    }
    const rowChild = dataArr?.rowChild ?? lev2?.rowChild;
    if (!rowChild) {
      return '';
    }
    if (rowChild.includes('|')) {
      return rowChild.substring(rowChild.indexOf('|') + 1).trim();
    }
    return rowChild.trim();
  }

  private resolveBrandDisplayName(dataArr: any): string {
    if (dataArr.colChild) {
      const parts = dataArr.colChild.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : dataArr.colChild;
    }
    const match = dataArr.rowVariableCode?.match(/_(\d+)$/);
    if (!match) {
      return '';
    }
    const brandIndex = parseInt(match[1], 10) - 1;
    const sortedBrands = [...(this._configService.brandSortId || [])].sort(
      (a: any, b: any) => a.sortId - b.sortId
    );
    return sortedBrands[brandIndex]?.name ?? '';
  }

  private resolveMetricFilter(data: any, candidate: string): string {
    const filter = (candidate || '').trim();
    if (!filter || !this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return '';
    }
    const options: string[] = (data?.metric_value || []).map((mv: any) => mv.option);
    if (options.includes(candidate)) {
      return candidate;
    }
    const normalizedFilter = filter.includes('|')
      ? filter.substring(filter.indexOf('|') + 1).trim()
      : filter;
    const match = options.find((opt: string) => opt?.trim() === normalizedFilter);
    return match || '';
  }

  preparemainChartData(data: any, metricFilter: string = '') {
    let i = 0;
    this.chartMainData = [];
    const isMultipleBrands = this._configService.selectedcompareacrossOption?.includes('Multiple Brands');
    const resolvedMetricFilter = this.resolveMetricFilter(data, metricFilter);
    const filteredMetricValue = (isMultipleBrands && resolvedMetricFilter)
      ? data.metric_value.filter((lev2: any) => lev2.option === resolvedMetricFilter)
      : data.metric_value;
    const useMetricCategory = this.shouldUseMetricAsCategory(data, resolvedMetricFilter);
    const useBrandCategory = this.shouldUseBrandAsCategory(data, resolvedMetricFilter);
    const multipleMetricGroups = (data?.metric_value?.length ?? 0) > 1;

    const result = this.transformRowChild(filteredMetricValue);

    result.forEach((lev2: any) => {
      let dataPoints = lev2.data ?? [];
      if (useMetricCategory && multipleMetricGroups) {
        dataPoints = dataPoints.length ? [dataPoints[0]] : [];
      }
       const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
      dataPoints.forEach((dataArr: any) => {
        let categoryName = '';
        const snapshotType = (this._configService.selectedSnapshotType || '').toLowerCase();
        if (snapshotType.includes('audience snapshot')) {
          const isAudienceMultiCohort = (data.metric_value?.length ?? 0) === 1;
          categoryName = isAudienceMultiCohort
            ? (dataArr.colChild?.split('|').pop()?.trim() || dataArr.colChild || '')
            : (dataArr.rowChild?.split('|').pop()?.trim() || dataArr.rowChild || '');
        } else if (snapshotType.includes('multi')) {
          const colParts = (dataArr.colChild || '').split('|');
          categoryName = colParts.length > 1 ? colParts[1] : (dataArr.colChild || this.resolveMetricDisplayName(lev2, dataArr));
        } else if (useBrandCategory) {
          categoryName = this.resolveBrandDisplayName(dataArr) || this.resolveMetricDisplayName(lev2, dataArr);
        } else {
          categoryName = this.resolveMetricDisplayName(lev2, dataArr);
        }
        let d1 = {
          "Series Name":this._configService.multiCohort?lev2.option: dataArr.rowChild||lev2.metric_group,
           "Category Name": categoryName,
          "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Change value vs PY": dataArr.changeVsPY,
          "Significance": "-1",
          "Sample size": dataArr.baseValueforLSorIs,
          "Significance2": "1",
          "XValue": ++i,
          "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
          "Sig_LowerLimt": this.Sig_LowerLimt,
          "Sig_UpperLimt": this.Sig_UpperLimt,
          "Significance_Value": dataArr.Significance_Value,
          "color": dataArr.color,
          "colorLinearGradient": dataArr.colorLinearGradient
        }
        this.chartMainData.push(d1);
        if (!isNaN(d1["Rounded Value"])) {
          const rounded = Math.round(parseFloat(d1["Rounded Value"]) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if(this.configuredProperties){
        if(this.configuredProperties?.sort=="ascending"){
          const sortedData = this.chartMainData.sort((a:any, b:any) => {
            // Compare the "Value" field in ascending order
            if (a["Value"] === "NA" && b["Value"] === "NA") {
              return 0; // If both are "NA", keep them in the same order
            }
            if (a["Value"] === "NA") {
              return 1; // If a is "NA", place it after b
            }
            if (b["Value"] === "NA") {
              return -1; // If b is "NA", place it after a
            }

            // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
            return a["Value"] - b["Value"];
          });
          this.chartMainData=sortedData;
        }
        if(this.configuredProperties?.sort=="descending"){
          const sortedDataDesc = this.chartMainData.sort((a:any, b:any) => {
            // Compare the "Value" field in descending order
            if (a["Value"] === "NA" && b["Value"] === "NA") {
              return 0; // If both are "NA", keep them in the same order
            }
            if (a["Value"] === "NA") {
              return -1; // If a is "NA", place it after b
            }
            if (b["Value"] === "NA") {
              return 1; // If b is "NA", place it after a
            }

            // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
            return b["Value"] - a["Value"]; // For descending order, reverse the comparison
          });
          this.chartMainData=sortedDataDesc;
        }
    }

    // this.chartMainData=this.chartMainData.slice(0,1);
  }

  transformRowChild(data: any[]): any[] {
    if (!data || data.length === 0) return data;

    // Check if all options are same
    const allOptionsSame =
      new Set(data.map(x => x.option?.trim())).size === 1;

    return data.map(item => {
      return {
        ...item,
        data: item.data.map((d: any) => {
          const parts = d.rowChild
            ?.split('|')
            .map((p: string) => p.trim()) || [];

          let updatedRowChild = '';

          if (parts.length === 0) return d;

          const last = parts[parts.length - 1]?.toLowerCase();

          // ✅ Rule 1: If last is Yes/No → take second last
          if (last === 'yes' || last === 'no') {
            updatedRowChild = parts[parts.length - 2] || '';
          }
          else if (allOptionsSame) {
            // ✅ Rule 2: all options same → last value
            updatedRowChild = parts[parts.length - 1] || '';
          }
          else {
            // ✅ Rule 3: different options → last two after first pipe
            if (parts.length >= 3) {
              updatedRowChild = `${parts[1]} | ${parts[2]}`;
            } else {
              updatedRowChild = parts.join(' | ');
            }
          }

          return {
            ...d,
            rowChild: updatedRowChild
          };
        })
      };
    });
  }

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }

  getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      // this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = 0;

      chartData[0].data = this.chartMainData
        .filter((item: any) => item['Label'] !== 'NA' && item['Label'] !== null)
        .map((item: any, idx: number) => ({ ...item, XValue: idx + 1 }));

      if (chartData[0].data.length == 0) {
        this.seriesData1 = [];
        return;
      }

      // const firstItem = chartData[0].data[0]['Series Name'];//extra added (req)
      

      // const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);
      //use full dataset (do not filter to a single series)
      const indiaData = chartData[0].data;
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Rounded Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Rounded Value']) || 0));

      this.max = maxValue + Math.ceil(maxValue * (this._configService.isRespondentLevel? 0.20:0.30));
      this.min = minValue + Math.floor(minValue * (this._configService.isRespondentLevel? 0.20:0.30));
      // ;
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

        value: item['Value'] == null ? 0 : this._configService.userRole != "superadmin" && item['Sample size'] != null && Number(item['Sample size']) > 0 && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff),
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        name: item['Category Name'],
        color : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],
        //color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[j++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
        visible: true,
        zIndex: 2,
        type: 'bar',
        dataLabels: {
          borderWidth: 0,
        },
        data: [{
          name: item['Category Name'],
          seriesName: item['Series Name'],
          ispercent: item["isPercentage"],
          y: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0)),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
          indexValue: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0)),
          actualIndexValue: item['ActualIndexValue'],
          dataLabels: {
            x: parseFloat(item['Value']) < 0 ? -10 : 10,
            align: parseFloat(item['Value']) < 0
              ? (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "left" : "right")
              : (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left")
          }
        }],
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => (item["Change value vs PY"])),
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Rounded Value"]),

        //calculationTypes: indiaData.map((item: { [x: string]: string }) => item["CalculationType"]),

        tooltip: [],
        isPercentage: item["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: item["Significance_Value"],

      }));

      if (minValue >= 0)
        this.min = 0

      this.labels = indiaData.map((item: { [x: string]: string }) => parseFloat(item["Label"]));

      // this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
      // this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

      this.categories = Array.from(indiaData.map((item: { [x: string]: string }) => item['Category Name']));
      this.categories = [''].concat(Array.from(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));


      i = 0;
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;

        // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
        if (parseFloat(item['Rounded Value']) < 0 && markerStyle === 'triangle') {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        const isLowSampleMarkerBasic = (this._configService.userRole != 'superadmin') && (Number(item['Sample size']) <= this._configService.ISthreshold);
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: 1,
          marker: {
            symbol: this.properties.markerStyle,
            // fillColor: 'red',
            // lineColor: 'red',
            // lineWidth: 2,
            fillColor : isLowSampleMarkerBasic ? 'transparent' : (this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color']),
            lineColor : isLowSampleMarkerBasic ? 'transparent' : (this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color']),
           //fillColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i]) : this.properties.gradientBarColor ? this.barService.linearGradients[i] : this.barService.color1[i],
            //lineColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
            radius: 9,
            lineWidth: 0,
          },
          enableMouseTracking: false,
          showInLegend: false,
          visible: true,
          data: [{
            name: item['Category Name'],
            y: !lowSample1 ? (item['Rounded Value'] == null || parseFloat(item['Rounded Value']) === 0) ? null :
              Number(parseFloat(item['Rounded Value']).toFixed(this.properties.decimalRoundOff)) :
              (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Rounded Value'] != null && parseFloat(item['Rounded Value']) !== 0) ?
                Number(parseFloat(item['Rounded Value']).toFixed(this.properties.decimalRoundOff)) : null,
            x: index + 1,
            z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ? 0 : item['Rounded Value'] == null ? 0 : parseFloat(item['Rounded Value']),
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: item['Significance_Value']
          }],
        });
      });




      //Top 10 data
      i = 0;
      this.seriesDataTop10 = indiaData.map((item: { [x: string]: string }) => ({

        value: item['Value'] == null ? 0 : this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff),
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        name: item['Category Name'],
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[j++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],
        //color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[j++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
        visible: true,
        zIndex: 2,
        type: 'bar',
        dataLabels: {
          borderWidth: 0,
        },
        data: [{
          name: item['Category Name'],
          seriesName: item['Series Name'],
          ispercent: item["isPercentage"],
          y: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0)),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
          indexValue: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0)),
          actualIndexValue: item['ActualIndexValue'],
          dataLabels: {
            x: parseFloat(item['Value']) < 0 ? -10 : 10,
            align: parseFloat(item['Value']) < 0
              ? (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "left" : "right")
              : (this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left")
          }
        }],
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => (item["Change value vs PY"])),
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Rounded Value"]),

        //calculationTypes: indiaData.map((item: { [x: string]: string }) => item["CalculationType"]),

        tooltip: [],
        isPercentage: item["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: item["Significance_Value"],

      }));

      this.seriesDataTop10 = this.seriesDataTop10.slice(0,10);
      i = 0;
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;

        // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
        if (parseFloat(item['Rounded Value']) < 0 && markerStyle === 'triangle') {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        if( i < 10 ){
          const isLowSampleMarkerTop10 = (this._configService.userRole != 'superadmin') && (Number(item['Sample size']) <= this._configService.ISthreshold);
          this.seriesDataTop10.push({
            name: item['Category Name'],
            type: 'scatter',
            zIndex: 1,
            marker: {
              symbol: this.properties.markerStyle,
              // fillColor: 'red',
              // lineColor: 'red',
              // lineWidth: 2,
              fillColor : isLowSampleMarkerTop10 ? 'transparent' : (this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color']),
              //fillColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i]) : this.properties.gradientBarColor ? this.barService.linearGradients[i] : this.barService.color1[i],
              //lineColor : this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
              lineColor : isLowSampleMarkerTop10 ? 'transparent' : (this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color']),
              radius: 9,
              lineWidth: 0,
            },
            enableMouseTracking: false,
            showInLegend: false,
            visible: true,
            data: [{
              name: item['Category Name'],
              y: !lowSample1 ? (item['Rounded Value'] == null || parseFloat(item['Rounded Value']) === 0) ? null :
                Number(parseFloat(item['Rounded Value']).toFixed(this.properties.decimalRoundOff)) :
                (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Rounded Value'] != null && parseFloat(item['Rounded Value']) !== 0) ?
                  Number(parseFloat(item['Rounded Value']).toFixed(this.properties.decimalRoundOff)) : null,
              x: index + 1,
              z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ? 0 : item['Rounded Value'] == null ? 0 : parseFloat(item['Rounded Value']),
              Sig_LowerLimt: this.Sig_LowerLimt,
              Sig_UpperLimt: this.Sig_UpperLimt,
              Significance_Value: item['Significance_Value']
            }],
          });
        }

      });
    }
    else{
      let value = 0;
      let maxValue = 0;
      let minValue = 0;
      // const firstItem = chartData[0].data[0]['Series Name'];

      // const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);
      //use full dataset (do not filter to a single series)
      const indiaData = chartData[0].data;
      this.chartCategories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Rounded Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Rounded Value']) || 0));
      this.max = maxValue + Math.ceil(maxValue * 0.20);
      this.min = minValue + Math.ceil(minValue * 0.16);
      let i = 0;
      this.seriesData1 = indiaData.map((item: { [x: string]: string }, index: number) => ({

        value: item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)),
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.LollipopService.sampleSizeConstant ? value : 0),
        name: item['Category Name'],
        seriesName: item['Series Name'],
        color: this.barService.colors[(i++) % this.barService.colors.length],
        visible: true,
        zIndex: 1,
        type: 'bar',
        tooltip: [],
        borderWidth: 0,
        pointWidth: 3,
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["ChangeVs"])),
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Rounded Value"]),
        data: [{
          name: item['Series Name'],
          y: !lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.LollipopService.sampleSizeConstant ? item['Value'] == null ? 0 :Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0),
          x: index,
        }],
        dataLabels: {
          borderWidth: 0,
        },
      }));

      this.categoryImages = indiaData.map((item: any) => item['Category Image']);
      // Scatter series (Marker1) - Limit to 1 data point
      i = 0;
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: 2,
          marker: {
            symbol: this.properties.markerStyle,
            fillColor : this.barService.colors[i % this.barService.colors.length],
            lineColor : this.barService.colors[i % this.barService.colors.length],
            radius: 9,
            lineWidth: 0,
          },
          showInLegend: false,
          tooltip: {
            enabled: false // Disable tooltip for this series
          },
          enableMouseTracking: false,
          visible: true,
          data: [{
            name: item['Category Name'],
            y: !lowSample1 ? item['Rounded Value'] == null ? null : parseFloat(item['Rounded Value']) == 0 ? null : parseFloat(item['Rounded Value']) : (parseFloat(item['Sample size']) > this.LollipopService.sampleSizeConstant ? item['Rounded Value'] == null ? null : parseFloat(item['Rounded Value']) == 0 ? null : parseFloat(item['Rounded Value']) : null),
            x: index,
            color: this.barService.colors[i % this.barService.colors.length], // Assign color based on index
          }],
        });
        i++;
      });
    }

  }

  customization():Observable<any> {
       const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
   
    return this._customSnapshotService.getChartCustomization("Horizontal Lollipop  Chart", this._customSnapshotService.selectedSnapshotType?.name,cohortType);

  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.LollipopService.applycustomization(event,item, this.properties);
    this.getData(this.jsonData, this.properties.datalabelStyle == "lowSample");
    this.getChart('chart-container'+this.id, this.seriesData1, this.seriesDataTop10, this.properties);
  }

  getChart(containerId: string, seriesData: any[],seriesDataTop10:any[], properties: any) {
    if(this.isOutput){
      if (!seriesData || seriesData.length === 0) {
        this.teardownChart();
        const containerEl = document.getElementById(containerId);
        if (containerEl) {
          containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      this.teardownChart();
      localStorage.setItem("properties", JSON.stringify(this.properties));
      let labels = this.labels;
      let serviceBar = this.barService;
      const updatedCategories = this.categoryImages;


      const maxLabelCharacters = this.popUp ? 30 : 20; // Adjust the maximum number of characters as needed

      const defaultCategories = this.categories;

      let popUp=this.popUp;

      const screenHeight = window.innerHeight; // Get the screen width

      // let height = '48%';
      // if (screenHeight <= 610) { // for 150% -> 593
      //   height = this.layoutNumber == 2 ? '55%' : '50%';
      // } else if (screenHeight <= 800) { // for 125% -> 738
      //   height = this.layoutNumber == 2 ? (this.popUp ? '50%' : '70%') : '50%';
      // } else if (screenHeight <= 1200) { //for 100% -> 953
      //   height = this.layoutNumber == 2 ? (this.popUp ? '50%' : '100%') : '50%';
      // }


      const configService = this._configService;
      this.properties.showLegend=false;
      properties=this.properties
      const component = this;

      const options: Highcharts.Options = {
        chart: {
          type: 'bar',
          // height: this.layoutNumber == 2 ? this.popUp ? height : this.height : height,
          backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            // height:150,
            fontSize: "0.7rem",
            overflow: 'visible',
            zIndex: 2
          },
          events: {
            //to hide the marker along with the bar,when legend is click for each bar
            redraw: function (this: any) {
              // Adjust scatter series position after redrawing the chart
              var chart = this,
                series = chart.series;

              series.forEach(function (ser: any) {

                if (ser.type === 'bar' && ser.type == 'scatter') {

                  ser[1].forEach(function (scatter: any) {
                    scatter.setVisible(ser.visible, false);
                  });
                }
              });
            },
            load: function (this: Highcharts.Chart) {
              const chart = this;
              component.chart = chart;
              component.resizeHandler = () => {
                if (component.chart?.renderer?.box?.parentNode) {
                  component.chart.reflow();
                }
              };
              window.addEventListener('resize', component.resizeHandler);
              component.barService.enableWheelScroll(chart);
            }
          }
        },

        title: {
          text: "",
          align: this.properties.chartTitlePosition,
          style: {
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            marginleft: '4%',
            fontSize: '2em',
            fontFamily: this.barService.textfont
          },
        },
        subtitle: {


        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false
        },

        //legend: this.barService.customizeLegend(this.chart, false, this.properties.legendPosition, this.properties,this.height),
        legend : {
          enabled : false,
        },
        xAxis: {
          gridLineWidth: this.properties.xaxisgridlines ? 1 : 0,
          categories: defaultCategories,
          lineColor: '#A2A2A2', // Change to desired axis line color
          lineWidth: 1,
          min: 1,
          // max: this.seriesData1.length / 2 < this.maxDataPoints ? this.seriesData1.length / 2 : this.maxDataPoints,
          max:this.popUp?(this.seriesData1.length/2>this.maxDataPoints?this.maxDataPoints:this.seriesData1.length/2):(this.seriesData1.length/2>6?(this.properties.legendPosition=="bottom"?4:6):this.seriesData1.length/2),
          scrollbar: {
            enabled: defaultCategories.length > (this.maxDataPoints + 1) ? true : false,
            height: 6, // Adjust the height of the scrollbar as needed
            barBackgroundColor: '#7f7f7f',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBorderWidth: 0,
            buttonArrowColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5,

          },
          showEmpty: false,
          //labels: {
          //  useHTML: true,
          //  formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          //    let labelContent = String(this.value);

          //    return '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; c + '">' + labelContent + '</span>';
          //  },
          //  rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by desired angle
          //}

      labels: {
  useHTML: true,

  style: {
    fontFamily: this.barService.textfont,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    color: this.properties.darkTheme
      ? this.barService.darkThemeTextColor
      : this.barService.defaultThemeTextColor
  },

  // Only use step: 2 when rotation is 90 or -90 degrees to prevent overlapping, but step: 1 for popup
  step: (() => {
    const rotation = this.barService.axisLabelOrientation(this.properties.yaxisLabelOrientation);
    if ((rotation === 90 || rotation === -90) && !this.popUp) {
      return 2;
    }
    return 1;
  })(),

  formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {

    const rotation = this.axis.options.labels?.rotation;
    const label = String(this.value);


    if (rotation === 90 || rotation === -90) {
      return `
        <div
          style="
            max-width: 50px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 1.2;
          "
          title="${label}"
        >
          ${label}
        </div>
      `;
    }


    const chart = this.axis.chart;
    const categories = this.axis.categories || [];
    const chartWidth = chart.plotWidth || 400;
    const chartHeight = chart.plotHeight || 300;
    const numCategories = Math.max(categories.length - 1, 1);

    const isSmallChart = chartWidth < 500 || chartHeight < 300;
    const isMediumChart = chartWidth >= 500 && chartWidth < 800;

    let baseWidth = Math.floor(chartWidth / numCategories);
    let padding, minWidth, maxWidth;

    if (popUp) {
      padding = isSmallChart ? 8 : isMediumChart ? 12 : 15;
      minWidth = isSmallChart ? 120 : isMediumChart ? 120 : 160;
      maxWidth = isSmallChart ? 200 : isMediumChart ? 250 : 300;
    } else {
      padding = isSmallChart ? 4 : isMediumChart ? 6 : 8;
      minWidth = isSmallChart ? 150 : isMediumChart ? 100 : 150;
      maxWidth = isSmallChart ? 150 : isMediumChart ? 200 : 250;
    }

    const labelWidth = Math.min(
      Math.max(baseWidth - padding, minWidth),
      maxWidth
    );

    function splitLabelToTwoLines(str: string, maxWidth: number) {
      const baseCharWidth = isSmallChart ? 5.5 : isMediumChart ? 6.0 : 6.5;
      const avgCharWidth = popUp ? baseCharWidth - 0.3 : baseCharWidth;
      const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);
      const minCharsPerLine = isSmallChart ? 8 : 10;
      const effectiveMaxChars = Math.max(maxCharsPerLine, minCharsPerLine);

      const words = str.split(' ');
      let line1 = '';
      let breakIndex = 0;

      for (let i = 0; i < words.length; i++) {
        const testLine = line1 ? line1 + ' ' + words[i] : words[i];
        if (testLine.length <= effectiveMaxChars || !line1) {
          line1 = testLine;
          breakIndex = i + 1;
        } else {
          break;
        }
      }

      let line2 = words.slice(breakIndex).join(' ');
      if (line2.length > effectiveMaxChars) {
        line2 = line2.substring(0, Math.max(effectiveMaxChars - 3, 5)) + '...';
      }

      return line2 ? `${line1}<br/>${line2}` : line1;
    }

    const labelContent = splitLabelToTwoLines(label, labelWidth);
    const isMultiLine = labelContent.includes('<br/>');
    const lineHeight = isMultiLine ? (isSmallChart ? '1.1' : '1.2') : '1.3';
    const maxLabelWidth = Math.min(labelWidth, 120);


    if (properties.axisImage) {
      const index = categories.indexOf(label);
      const imagePath =
        serviceBar.baseImgPath + updatedCategories[index] + '.png';
      const imageSize = isSmallChart ? '1.5em' : isMediumChart ? '2em' : '2.5em';

      return `
        <span style="
          display:inline-block;
          width:${imageSize};
          height:${imageSize};
          background:url(${imagePath}) no-repeat center center;
          background-size:cover;
        "></span>
      `;
    }


    return `
      <div
        style="
          max-width:${maxLabelWidth}px;
          width:${maxLabelWidth}px;
          text-align:right;
          line-height:${lineHeight};
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        "
        title="${label}"
      >
        ${labelContent}
      </div>
    `;
  },

  
  rotation: this.barService.axisLabelOrientation(
    this.properties.yaxisLabelOrientation
  )
}

        },

        yAxis: {

          max: this.max,
          min: this.min,
          plotLines: [{
            value: 0,
            width: 1
          }],
          tickInterval: this.getTickInterval(this.maxBarValue),
          gridLineWidth: this.properties.yaxisgridlines ? 1 : 0,


          labels: {
            enabled: false,
            format: this.properties.datalabelFormat == "percentage" ? '{value}%' : '{value}',
            style: {
              fontFamily: this.barService.textfont,
              color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            },
          },
          title: {
            text: '', // Set an empty string to hide the yAxis title
          },
        },
      tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       backgroundColor:  'white',  
        shadow: false,
       outside:true,
        style: {
           zIndex: 9999,
           backgroundColor: 'white',
          pointerEvents: 'none' // Prevent tooltip from interfering with mouse events
        },
         positioner: function (labelWidth: number, labelHeight: number, point: any) {
    // Show tooltip above the bar, or below if too close to the top
    let chart = this.chart;
    let y = point.plotY + chart.plotTop - labelHeight - 10; // 10px gap above
    if (y < chart.plotTop) {
      y = point.plotY + chart.plotTop + 10; // 10px gap below if not enough space above
    }
    // Center horizontally on the bar
    let x = chart.plotLeft + point.plotX - labelWidth / 2;
    // Prevent overflow left/right
    x = Math.max(chart.plotLeft, Math.min(x, chart.plotLeft + chart.plotWidth - labelWidth));
    return { x, y };
  },

        formatter: function (this: any) {
          //disable tootltip for marker
          if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = properties.darkTheme ? '#f5f5f5' : '#b3b3b3';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x - 1] : this.y;

 
if (isDefaultTooltip == 'default') {
  const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 20px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;zIndex:999">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${this.point.name}: </span>
      <b style="margin-left:4px;">${text}</b>
    </div>`;
  return content;
}
      else {
    const commonContent =
              `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
              `<span><strong>Category Name:</strong></span> ${this.point.name}<br>` +
              `<span><strong>Value:</strong></span> ${text}`;



            return commonContent + '</div>';
}

        },
      },


        plotOptions: {
          series: {
            borderWidth: 0,
            animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
            // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
            events: {
              //when a legend is clicked fro the bar,bar must disappear
              legendItemClick: function (this: any) {
                var series = this.chart.series,
                  selectedSeriesName = this.name;

                // Loop through all series
                for (var i = 0; i < series.length; i++) {
                  // Check if the series name matches the clicked legend's series name
                  if (series[i].name === selectedSeriesName) {
                    // Toggle visibility of both bar and scatter series
                    series[i].setVisible(!series[i].visible, false);
                    if (series[i].type == 'scatter') {
                      series[i].scatterSeries.setVisible(!series[i].visible, false);
                    }
                  }
                }

                // Redraw the chart
                this.chart.redraw();

                // Prevent default legend item click action
                return false;
              }
            }
          },
          bar: {
            pointPadding: 2,
            groupPadding: 3,
            grouping: false,
            stacking: undefined,
            pointWidth: 3,

            shadow: this.properties.shadow ? {
              color: this.barService.shadowColor,
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
            } : false,
            dataLabels: {
              style: {
                backgroundColor: this.barService.transparentBackground,
                textOutline: 'none',
                color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? 'white' : this.properties.dataLabelColor || this.barService.darkThemeTextColor)
                  : (this.properties.dataLabelColor === 'default'
                    ? 'black'
                    : this.properties.dataLabelColor || this.barService.defaultThemeTextColor),
                fontSize: this.properties.dataLabelSize,
                fontWeight: "normal",
                fontFamily: this.barService.textfont,
                whiteSpace: 'normal',
              },
              useHTML: true,

              //overflow: 'allow',
              overflow: 'justify',
              crop: false,
              enabled: this.properties.showDataLabel,

              inside: false,
              //  x: this.properties.dataLabel_y_positionHorizontal,
              //  y: this.properties.dataLabel_x_position,
              // x:  this.properties.datalabelStyle == 'default' || this._configService.isIndexSelected?  this.properties.dataLabel_y_positionHorizontal : this.properties.dataLabel_y_positionHorizontal_sig,
              x: 10,// this.properties.datalabelStyle == 'default' ? this.properties.dataLabel_y_positionHorizontal+10 :(this.properties.datalabelStyle != 'index' ?this.properties.dataLabel_y_positionHorizontal_sig + 10:100),
              y:  this.properties.dataLabel_x_position,

              rotation: this.properties.datalabelOrientation,

              align: this.properties.dataLabelPosition == "middle" ? "center" : this.properties.dataLabelPosition == "top" ? "right" : "left",
              allowOverlap: true,

              formatter: function (this: any) {

                if (properties.datalabelStyle == "index") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;
                  // ;
                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1]);
                  // this.series.userOptions.tooltip[this.point.x - 1] = text;
                  // return (
                  //   '<span >' + text + '</span>'
                  // );



                  // let text2 =
                  //   this.series.userOptions.roundedValue[this.point.x - 1] === 0
                  //     ? serviceBar.nullValueText
                  //     : (this.series.userOptions.roundedValue[this.point.x - 1] == -1
                  //       ? -1
                  //       : ((this.series.userOptions.roundedValue[this.point.x - 1] != null)
                  //         ? this.point.indexValue
                  //         : serviceBar.nullValueText));
                  let text2 =
                    this.point.actualIndexValue == null
                      ? serviceBar.nullValueText
                      : (this.series.userOptions.roundedValue[this.point.x - 1] == -1
                        ? -1
                        : ((this.series.userOptions.roundedValue[this.point.x - 1] != null)
                          ? this.point.indexValue
                          : serviceBar.nullValueText));
                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSize[this.point.x - 1]);


                  let color = configService.CheckIndexColoring(text2);
                  //// ;
                  this.series.userOptions.tooltip[this.point.x - 1] = text + "(" + text2 + ")";
                  return (
                    '<span style="font-size:0.5rem;">' + text + '</span><br>' +
                    '<span style="color:' + color + ';font-size:0.45rem;">' + " " + '(' + text2 + ')</span>'
                  );
                }

                if (properties.datalabelStyle == "significance + changeVs") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' +
                    '<span>' + text
                    //+
                    + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';

                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return (
                    finalText
                  );


                }
                if (properties.datalabelStyle == "sigChange") {

                  let changeText = this.series.userOptions.isPercentage ? (this.series.userOptions.changeValueSeries[this.point.x - 1]) * 100 :
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  let textCheck = configService.CheckLSorIScondition(configService.userRole, this.y, this.series.userOptions.sampleSize[this.point.x - 1]);
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? textCheck + (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '') : serviceBar.nullValueText;

                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let sigClass = this.series.userOptions.Significance_Value < this.series.userOptions.Sig_LowerLimt ? 'red' : this.series.userOptions.Significance_Value > this.series.userOptions.Sig_UpperLimt ? 'green' : 'black';

                  // if (parseFloat(changeText) > 0) {
                  //   changeText = "+" + changeText;
                  // }
                  if (this.series.userOptions.changeValueSeries[this.point.x - 1] == null || this.series.userOptions.changeValueSeries[this.point.x - 1] == 'NA') {
                    let finalText = '<span>' +
                      '<span>' + text
                      //+
                      + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '<span>&nbsp<br>' +
                        '<span style="color:' + sigClass + ';font-size: ' + serviceBar.changeValueFontSize + '; "> (NA)</span>'
                        : '') +
                      '</span>';
                    let tooltipText ='<span>' +
                      '<span>' + text
                      //+
                      + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '<span>&nbsp' +
                        '<span style="color:' + sigClass + ';font-size: ' + serviceBar.changeValueFontSize + '; "> (NA)</span>'
                        : '') +
                      '</span>';

                    this.series.userOptions.tooltip[this.point.x - 1] = tooltipText;

                    return (
                      finalText
                    );
                  }
                  else {
                    let finalText = '<span>' +
                      '<span>' + text
                      //+
                      + '</span>' +

                      (this.series.userOptions.Significance_Value == 0 ?
                        '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (this.series.userOptions.Significance_Value + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                      :
                      ((this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null && textCheck != 'I/S') ? '<span>&nbsp<br>' +
                        '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                        : '')) +
                      '</span>';
                      let tooltipText = '<span>' +
                      '<span>' + text
                      //+
                      + '</span>' +

                      (this.series.userOptions.Significance_Value == 0 ?
                        '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (this.series.userOptions.Significance_Value + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                        :
                      ((this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText && textCheck != 'I/S') ? '<span>&nbsp' +
                        '<span style="color:' + sigClass + '; font-size: ' + serviceBar.changeValueFontSize + ';">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')' + '</span>'
                        : '')) +
                      '</span>';

                    this.series.userOptions.tooltip[this.point.x - 1] = tooltipText;

                    return (
                      finalText
                    );
                  }

                }
                if (properties.datalabelStyle == "change") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text + "  " +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '</span>' : '');
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return (
                    finalText
                  );

                }

                if (properties.datalabelStyle == "ls") {


                  let text = parseFloat(this.series.userOptions.sampleSize[this.point.x - 1]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                  let finalText = '<b>' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }
                if (properties.datalabelStyle == "significance") {
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let finalText = '<span >' + text + (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return (
                    finalText
                  )

                }
                if (properties.datalabelStyle == "default") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;
                  // ;
                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1]);
                  this.series.userOptions.tooltip[this.point.x - 1] = text;
                  return (
                    '<span >' + text + '</span>'
                  );
                }
                if (properties.datalabelStyle == "datalabel") {
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x - 1] = text;
                  return (
                    '<span >' + text + '</span>'
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  let sig1 = this.series.userOptions.significance2[this.point.x - 1];
                  let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                      '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return (
                    finalText
                  );
                }

                return this.y != 0 ? this.y : serviceBar.nullValueText;

              },
            },
          },
        },
        series: properties.top10 ? seriesDataTop10 : seriesData,


      }
      this.chart = Highcharts.chart('chart-container' + this.id, options);

      // let object = {
      //   chartType: "horizontal bar chart",
      //   widgetName: this.WidgetDetails.widgetName,
      //   widgetNumber: this.WidgetDetails.widgetNumber,
      //   pageNumber: this.pageNumber,
      //   data: this.chartMainData,
      //   properties: this.properties,
      //   selectionSummary: this._configService.selectionSummaryTextTitle,
      //   LSthreshold: this._configService.LBthreshold,
      //   ISthreshold: this._configService.ISthreshold,
      //   conversionPercentage: [],
      //   MDSdata: []
      // };

      // this._configService.listOfPptChartObjects.push(object);
    }else{
      localStorage.setItem("properties", JSON.stringify(this.properties));
      const updatedCategories = this.LollipopService.updatedCategories;
      const numberOfTicks = 10; // Adjust this value according to your preference
      // const tickInterval = Math.ceil(this.max / numberOfTicks);
      const tickInterval = 20;
      const maxCategoriesToShow = 6;
      let sampleSizeConstant = this.LollipopService.sampleSizeConstant;
      const serviceBar = this.LollipopService;
      const categoryImages = this.categoryImages;

      const defaultCategories = this.chartCategories;
      let plotBandsConfig: { color: string; from: number; to: number; }[] = [];
      const numPlotBands = defaultCategories.length;

      if (this.properties.plotBands) {
        for (let i = 0; i < numPlotBands; i += 2) {
          const from = i + 0.5;
          const to = from + 1;
          plotBandsConfig.push({ color: this.properties.darkTheme ? this.LollipopService.plotBandsdark : this.LollipopService.plotBandsColor, from, to });
        }
      }
      this.chart = Highcharts.chart(containerId, {
        chart: {
          type: 'bar',
          backgroundColor: this.properties.darkTheme ? this.LollipopService.darkThemeBackgroundColor : this.LollipopService.defaultThemeBackgroundColor,
          style: {
            fontFamily: this.LollipopService.textfont,
            color: this.properties.darkTheme ? this.LollipopService.darkThemeTextColor : this.LollipopService.defaultThemeTextColor,
          },
        },
        title: {
          text: "",
          align: this.properties.chartTitlePosition,
          style: {
            color: this.properties.darkTheme ? this.LollipopService.darkThemeTextColor : this.LollipopService.defaultThemeTextColor,
            fontFamily: this.LollipopService.textfont
          },
        },
        subtitle: {
        },
        //legend: this.LollipopService.customizeLegend(this.properties.showLegend, this.properties.legendPosition, this.properties),
        legend : {
          enabled : false,
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false
        },
        xAxis: {
          visible: true,
          //gridLineWidth: this.properties.gridlines,
          categories: this.chartCategories,
          plotBands: plotBandsConfig,
          min: 0,
          max: maxCategoriesToShow,
          showEmpty: false,
          labels: {

            useHTML: true,
            style: {
              color: this.properties.darkTheme ? this.LollipopService.darkThemeTextColor : this.LollipopService.defaultThemeTextColor,
              textOverflow: 'ellipsis', // Display ellipsis for overflowed text
              width: this.properties.axisLabelOrientation != "vertical" ? '100%' : '35%',
              fontSize:"0.7rem"
            },
            formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
              if (properties.axisImage) {
                var index = defaultCategories.indexOf(String(this.value));
                var category1 = serviceBar.baseImgPath + categoryImages[index] + '.png'
                if (category1) {
                  return '<span style="display: inline-block; width: 2em; height: 2em; background: url(' + category1 + ') no-repeat center center; background-size: cover;"></span>';
                } else {
                  return '<span style="display: inline-block; width: 2em; height: 2em; background: url(' + updatedCategories[0].image + ') no-repeat center center; background-size: cover;"></span>';
                }
              } else {
                let labelContent = String(this.value);
                return `<div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding: 0% 4%;" title="${String(this.value)}">${String(this.value)}</div>`;
              }
            },

            rotation: this.LollipopService.xAxisLabelOrientation(this.properties.axisLabelOrientation, this.properties), // Rotate labels by -90 degrees (or any other desired angle)
          },
          scrollbar: {
            enabled: this.chartCategories.length - 1 > maxCategoriesToShow ? true : false,
            height: 6, // Adjust the height of the scrollbar as needed
             barBackgroundColor: '#7f7f7f',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: this.properties.darkTheme ? this.LollipopService.darkThemeBackgroundColor : this.LollipopService.defaultThemeBackgroundColor,
            buttonBackgroundColor: this.properties.darkTheme ? this.LollipopService.darkThemeBackgroundColor : this.LollipopService.defaultThemeBackgroundColor,
            buttonBorderWidth: 0,
            buttonArrowColor: this.properties.darkTheme ? this.LollipopService.darkThemeBackgroundColor : this.LollipopService.defaultThemeBackgroundColor,
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.properties.darkTheme ? this.LollipopService.darkThemeBackgroundColor : this.LollipopService.defaultThemeBackgroundColor,
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5
          },
        },

        yAxis: {
          title: "",
          max: this.max,
          min: this.min,
          plotLines: [{
            value: 0,
            width: 1
          }],
          gridLineWidth: this.properties.gridlines ? 1 : 0,
          labels: {
            rotation: this.LollipopService.xAxisLabelOrientation(this.properties.yaxisLabelOrientation, this.properties), // Rotate labels by -90 degrees (or any other desired angle)
            format: this.properties.datalabelFormat == "number" ? '{value}' : '{value}%',
            style: {
              color: this.properties.darkTheme ? this.LollipopService.darkThemeTextColor : this.LollipopService.defaultThemeTextColor,
            },
          },
          tickInterval: tickInterval,
        },
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',
          outside:true,
          formatter: function (this: any) {
            if (this.series.name === 'Marker1') return false;
            let isDefaultTooltip = properties.toolTipStyle;
            const dotColor = this.series.color; // Get the series color
            const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            let text = properties.showDataLabel == true ? this.series.userOptions.tooltip[this.point.x] : this.y;
            if (isDefaultTooltip == "style1") {
              const commonContent =
                `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color:${backgroundcolor2}; width:110%">` +
                `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                `<span><strong>Series Name:</strong></span> ${this.series.name}<br>` +
                `<span><strong>Category Name:</strong></span> ${this.key}<br>` +
                `<span><strong>Value:</strong></span> ${text}`;
              return commonContent + '</div>';
            }
            else {
              // const content =
              //   `<div style="background-color: ${backgroundcolor}; padding: 5px; align-items: center; border: 1px solid ${dotColor}; ">` +
              //   `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5px;"></div>` +
              //   ` ${this.series.name}` +
              //   `<div style="display: block; margin-top: 5px;"><strong>Value:</strong> ${text}</div>`;

              // return content + '</div>';
              const commonContent =
                `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};  width: fit-content;z-index: 100; padding: 2%; border-radius: 5px;font-size: 0.7em; margin: 0; background-color: ${backgroundcolor2};">` +
                //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
                `${this.series.name}: ` +
                ` ${text}`;

              return commonContent + '</div>';

            }
          },
        },

        plotOptions: {
          series: {
            animation: false,
            events: {
              legendItemClick: function (this: any) {
                var series = this.chart.series,
                  selectedSeriesName = this.name;

                // Loop through all series
                for (var i = 0; i < series.length; i++) {
                  // Check if the series name matches the clicked legend's series name
                  if (series[i].name === selectedSeriesName) {
                    // Toggle visibility of both bar and scatter series
                    series[i].setVisible(!series[i].visible, false);
                    if (series[i].scatterSeries) {
                      series[i].scatterSeries.setVisible(!series[i].visible, false);
                    }
                  }
                }

                // Redraw the chart
                this.chart.redraw();

                // Prevent default legend item click action
                return false;
              }
            }
          },
          bar: {
            pointPadding: 2,
            groupPadding: 3,
            grouping: false,
            stacking: undefined,
            pointWidth: 3,
            allowOverlap: this.properties.allowOverlap,
            dataLabels: {
              useHTML: true,
              style: {
                backgroundColor: this.LollipopService.transparentBackground,
                textOutline: 'none',
                color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? this.LollipopService.darkThemeTextColor : this.properties.dataLabelColor || this.LollipopService.darkThemeTextColor)
                  : (this.properties.dataLabelColor === 'default'
                    ? 'black'
                    : this.properties.dataLabelColor || this.LollipopService.defaultThemeTextColor),
                fontSize: this.properties.dataLabelSize,
                fontWeight: "normal",
              },
              enabled: this.properties.showDataLabel,
              crop: false,
              overflow: 'allow',
              rotation: this.properties.datalabelOrientation,
              align: this.properties.dataLabelPosition === "right" ? "left" : (this.properties.dataLabelPosition === "left" ? "right" : "center"), // Set alignment based on the value of this.properties.dataLabelPosition,
              formatter: function (this: any) {
                let sigcolor;
                const upwardTriangle = '&#9650';
                const downwardTriangle = '\u25BC';
                const upColor = 'green';
                const downColor = 'red';
                let changeText; let finalText;
                let text;
                let sig; let sColor;
                const paddingStyle = this.y < 0 ? 'padding-right: 4em;' : (this.y > 0 ? 'padding-left: 4em' : 'padding-left : 2em');

                if (this.series.userOptions.roundedValue[this.point.x] == null) {
                  finalText = '<span style="' + paddingStyle + '">' + 'NA' + '</span>';
                  this.series.userOptions.tooltip[this.point.x] = 'NA';
                  return finalText;
                }

                if (properties.datalabelStyle == "significance + changeVs") {
                  text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  sig = this.series.userOptions.significance[this.point.x];
                  sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let changeColor = properties.darkTheme ? 'white' : 'black'

                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }

                  finalText = (
                    '<span style="' + ( this.y < 0 ? 'padding-right: 7.5em;' : (this.y > 0 ? 'padding-left: 7.5em' : 'padding-left :5em')) + '">' + text +
                    (changeText ? '&nbsp<span style="color:' + ';">' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  );
                  this.series.userOptions.tooltip[this.point.x] = (
                    '<span>' + text +
                    (changeText ? '&nbsp<span style="color:' + ';">' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  );
                  return finalText;
                }


                if (properties.datalabelStyle == "datalabel") {
                  text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  finalText = (
                    '<span style="' + paddingStyle + '">' + text + '</span>'
                  );
                  this.series.userOptions.tooltip[this.point.x] = (
                    '<span>' + text + '</span>'
                  );
                  return finalText;
                }

                if (properties.datalabelStyle == "change") {
                  text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  changeText = this.series.userOptions.changeValueSeries[this.point.x];

                  let changeColor = properties.darkTheme ? 'white' : 'black';

                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }

                  finalText = (
                    '<span style="' + ( this.y < 0 ? 'padding-right: 7em;' : (this.y > 0 ? 'padding-left: 7em' : 'padding-left : 4em')) + '">' + text +
                    (changeText ? '&nbsp<span style="color:' + ';">' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '</span>' : '') +
                    '</span>'
                  );
                  this.series.userOptions.tooltip[this.point.x] = (
                    '<span>' + text +
                    (changeText ? '&nbsp<span style="color:' + ';">' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '</span>' : '') +
                    '</span>'
                  );
                  return finalText;
                }

                if (properties.datalabelStyle == "significance") {
                  text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  sig = this.series.userOptions.significance[this.point.x];
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  sigcolor = sig > 0 ? upColor : (sig < 0 ? downColor : '');

                  finalText = (
                    '<span style="' + ( this.y < 0 ? 'padding-right: 5em;' : (this.y > 0 ? 'padding-left: 5em' : 'padding-left : 4em')) + '">' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                  );
                  this.series.userOptions.tooltip[this.point.x] = (
                    '<span>' + text + '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span></span>'
                  );
                  return finalText;
                }

                if (properties.datalabelStyle == "significance2") {
                  text = this.y + (properties.datalabelFormat == "percentage" ? '%' : '');
                  changeText = this.series.userOptions.changeValueSeries[this.point.x];
                  sig = this.series.userOptions.significance[this.point.x];
                  let sig1 = this.series.userOptions.significance2[this.point.x];
                  sColor = sig > 0 ? 'green' : (sig < 0 ? 'red' : '');
                  let s = sig > 0 ? upwardTriangle : (sig < 0 ? downwardTriangle : '');
                  let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : properties.darkTheme ? 'white' : 'black');

                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }

                  finalText = (
                    '<span style="' + ( this.y < 0 ? 'padding-right: 7.5em;' : (this.y > 0 ? 'padding-left: 7.5em' : 'padding-left : 4em')) + '">' + text +
                    (changeText ? '&nbsp<span style="color:' + ';">' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  );
                  this.series.userOptions.tooltip[this.point.x] = (
                    '<span>' + text +
                    (changeText ? '&nbsp<span style="color:' + ';">' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  );
                  return finalText;
                }

                if (properties.datalabelStyle == 'ls') {
                  text = parseFloat(this.series.userOptions.sampleSize[this.point.x]) > sampleSizeConstant ? this.y != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : 'NA' : 'LS';

                  finalText = (
                    '<span style="' + paddingStyle + '">' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                  this.series.userOptions.tooltip[this.point.x] =(
                    '<span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                  return finalText;
                }
                finalText = text;
                this.series.userOptions.tooltip[this.point.x] = finalText
                return finalText;
              }
            },
          },
        },
        series: seriesData,
      } as any)

    }
  }

   getTickInterval(maxBarValue: number, precision: number = 0.05): number {
      if (maxBarValue <= 0) return 0.05;

      const desiredTickCount = 4;
      const rawInterval = maxBarValue / desiredTickCount;

      const step = 1 / precision;
      const rounded = Math.ceil(rawInterval * step) / step;

      return rounded + 0.01;
  }

  userselectedproperties() {
    this.data["properties"][0] = this.properties;
    return JSON.stringify(this.data).toString();
  }
  index = -1;

  private teardownChart(): void {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  ngOnDestroy(): void {
    this.teardownChart();
    this.subscriptions.unsubscribe();
  }
}
